(function() {
    'use strict';
a3_cabin_reports.factory('SettingsMain', SettingsMain);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SettingsMain
    * @description 
    *    Generic add, edit or remove
    * @ngInject
    */
function SettingsMain($log, localStorageMD5Service, FlightFactory) {

        /**
        * Initialize the PageMainSettings
        * @memberof SettingsMain
        */
		function PageMainSettings() {
			this.EditingPage = null;
			this.IsAssessmentEnabled = null;
            this.calendarViewStyle = null;
            this.selectedDate = null;
            this.IsShopInTheCloudEnable = null;
		}
			
		var service = {
			getSettings : getSettings,
			setSettings : setSettings,
			getEditingPage : getEditingPage,
			setEditingPage : setEditingPage,
			setIsAssessmentEnabled : setIsAssessmentEnabled,
            getIsAssessmentEnabled: getIsAssessmentEnabled,
			setIsShopInTheCloudEnable : setIsShopInTheCloudEnable,
            getIsShopInTheCloudEnable : getIsShopInTheCloudEnable,
            setCalendarViewStyle : setCalendarViewStyle,
            getCalendarViewStyle : getCalendarViewStyle,
            getCalendarSelectedDate : getCalendarSelectedDate,
            setCalendarSelectedDate : setCalendarSelectedDate
		}
		
        //factory functions
         /**
         * Get Application Settings
         * @memberof SettingsMain
         * @returns {object} settings 
         */
		function getSettings() {
			var settings = new PageMainSettings();
			var settingsStored = localStorageMD5Service.get('settingsMain');
			if (settingsStored) {
				if (settingsStored.EditingPage)
					settings.EditingPage = settingsStored.EditingPage;
				

				settings.IsAssessmentEnabled = settingsStored.IsAssessmentEnabled;
                settings.calendarViewStyle = settingsStored.calendarViewStyle;
                settings.selectedDate = settingsStored.selectedDate;
                settings.IsShopInTheCloudEnable = settingsStored.IsShopInTheCloudEnable
			}
			return settings;
		}
	 
	    /**
         * Set Application Settings
         * @param {object} settings
         * @memberof SettingsMain
         */
		function setSettings(settings) {
			localStorageMD5Service.set('settingsMain', settings);
		}

        /**
         * Get editing page
         * @memberof SettingsMain
         * @returns {string} EditingPage
         */
		function getEditingPage() {
			var settings = getSettings();
			return settings.EditingPage;
		}
    
        /**
         * Set editing page
         * @param {string} value
         * @memberof SettingsMain
         */
		function setEditingPage(value) {
			var settings = getSettings();
			settings.EditingPage = value;
			setSettings(settings);
		}

        /**
         * Get if  assessment  is enabled
         * @memberof SettingsMain
         * @returns {boolean} isEnabled
         */
		function getIsAssessmentEnabled() {
			var settings = getSettings();
            var isEnabled = settings.IsAssessmentEnabled;
             if(isEnabled){
                 var flights = FlightFactory.getFlightsFromStorage();
                 if (flights){
                      for(var i=0;i<flights.length;i++){
                          if((flights[i].AcType == 'DH4'|| flights[i].AcType == 'DH8' ||  flights[i].AcType == 'AT4') && flights[i].isDHC ){
                             isEnabled=false;
                             break;
                         }
                    }
                 }
             }
             
            return isEnabled;
		}
    

        /**
         * Set if  assessment  is enabled
         * @param {string} value
         * @memberof SettingsMain
         */
		function setIsAssessmentEnabled(value) {
			var settings = getSettings();
			settings.IsAssessmentEnabled = value;
			setSettings(settings);
		}
        /**
         * Set if  ShopInTheCloud  is enabled
         * @param {string} value
         * @memberof SettingsMain
         */
		function setIsShopInTheCloudEnable(value) {
			var settings = getSettings();
            if(!value)
                value = false;
			settings.IsShopInTheCloudEnable = value;
			setSettings(settings);
		}

        function getIsShopInTheCloudEnable(){
            var settings = getSettings();
            return settings.IsShopInTheCloudEnable;
        }

           /**
         * Get prefered calendar view style
         * @memberof SettingsMain
         * @returns {string} viewStyle
         */
		function getCalendarViewStyle() {
			var settings = getSettings();
            var viewStyle = settings.calendarViewStyle;
            
            return viewStyle;
		}
    
        /**
         * Set prefered calendar view style
         * @param {string} value
         * @memberof SettingsMain
         */
		function setCalendarViewStyle(value) {
			var settings = getSettings();
			settings.calendarViewStyle = value;
			setSettings(settings);
		}
    
        /**
         * Get selected calendar date
         * @memberof SettingsMain
         * @returns {string} selectedDate
         */
        function getCalendarSelectedDate() {
            var settings = getSettings();
            var selectedDate = settings.selectedDate;
            
            return selectedDate;
        }
        /**
         * Set selected calendar date
         * @param {string} value
         * @memberof SettingsMain
         */
        function setCalendarSelectedDate(value) {
            var settings = getSettings();
            settings.selectedDate = value;
            setSettings(settings);
        }

		return service;
	}
    
})();
